import { Box, Typography } from "@material-ui/core";
import React from "react";
import { formatUnixToDateString } from "safetySensors/functions/sensorFunctions";
import styles from "./eventHistory.module.scss";
import { StatusIndicator } from "./statusIndicator";
import { t } from "i18next";

interface IEventHistory {
  date: number;
  event: string;
  value: boolean;
  description: string;
}
export const EventHistory = ({ date, event, value }: IEventHistory) => {
  const convertedDate = formatUnixToDateString(date);
  return (
    <div className={styles.container}>
      <Typography variant="h4">{convertedDate}</Typography>
      <Box display="flex" flexDirection="row" alignItems="center">
        <StatusIndicator
          status={value ? "warning" : "ok"}
          text={`${event} ${value ? "" : t("Ok")}`}
        />
      </Box>
    </div>
  );
};
